import { request } from "./http";

export const getCompany = () =>
  request<{
    id: number;
    name: string;
    cnpj?: string | null;
    cpf?: string | null;
    legal_name?: string | null;
    phone?: string | null;
    website?: string | null;
    email?: string | null;
    address?: string | null;
    plan?: string | null;
    next_renewal?: string | null;
    require_evolution?: boolean;
    language: string;
    timezone: string;
  }>("/api/company");

export const updateCompany = (body: Partial<{
  name: string;
  cnpj: string | null;
  cpf: string | null;
  legal_name: string | null;
  phone: string | null;
  website: string | null;
  email: string;
  address: string | null;
  require_evolution: boolean;
  language: string;
  timezone: string;
}>) =>
  request<{
    id: number;
    name?: string;
    cnpj?: string | null;
    cpf?: string | null;
    legal_name?: string | null;
    phone?: string | null;
    website?: string | null;
    email?: string;
    address?: string | null;
    require_evolution?: boolean;
    language?: string;
    timezone?: string;
  }>("/api/company", { method: "PUT", body: JSON.stringify(body) });

export const getCompanySubscription = () =>
  request<import("../types").CompanySubscription | null>(
    "/api/company/subscription"
  );

export const getCompanySubscriptionInvoices = () =>
  request<import("../types").CompanySubscriptionInvoice[]>(
    "/api/company/subscription/invoices"
  );

export const createStripePortal = () =>
  request<{ url: string }>("/api/company/stripe/portal", { method: "POST" });

export const createStripeCheckout = (plan: string) =>
  request<{ url: string }>("/api/company/stripe/checkout", {
    method: "POST",
    body: JSON.stringify({ plan }),
  });

export const listCompanyRooms = () =>
  request<Array<{ id: number; name: string; capacity: number }>>("/api/company/rooms");

export const createCompanyRoom = (body: { name: string; capacity: number }) =>
  request<{ id: number }>("/api/company/rooms", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const deleteCompanyRoom = (id: number) =>
  request<void>(`/api/company/rooms/${id}`, { method: "DELETE" });

export const listScheduleExceptions = () =>
  request<Array<{ id: number; employee_id: number | null; start_datetime: string; end_datetime: string; description: string | null; repeat_weekday: number | null; repeat_month_day: number | null }>>("/api/company/exceptions");

export const createScheduleException = (body: { employee_id: number | null; start_datetime: string; end_datetime: string; description?: string; repeat_weekday?: number | null; repeat_month_day?: number | null }) =>
  request<{ id: number }>("/api/company/exceptions", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const deleteScheduleException = (id: number) =>
  request<void>(`/api/company/exceptions/${id}`, { method: "DELETE" });

export const listCompanySessions = () =>
  request<Array<{ id: number; weekday: number; start_time: string; duration_minutes: number; slot_limit: number | null }>>("/api/company/sessions");

export const createCompanySession = (body: { weekday: number; start_time: string; duration_minutes: number; slot_limit?: number | null }) =>
  request<{ id: number }>("/api/company/sessions", {
    method: "POST",
    body: JSON.stringify(body),
  });

export const deleteCompanySession = (id: number) =>
  request<void>(`/api/company/sessions/${id}`, { method: "DELETE" });

export const updateCompanySession = (id: number, body: { weekday?: number; start_time?: string; duration_minutes?: number; slot_limit?: number | null }) =>
  request<void>(`/api/company/sessions/${id}`, {
    method: "PUT",
    body: JSON.stringify(body),
  });

export const getAvailableSlots = (params: { employee_id: number; specialty_id: number; start: string; token?: string | null }) => {
  const q = new URLSearchParams(params as any).toString();
  return request<Array<{ start: string; end: string; available: boolean }>>(`/api/available-slots?${q}`);
};
